export default __webpack_public_path__ + "static/media/aligner.f5cdf997.jpg";